import { alpha, darken, lighten, Theme } from '@mui/material/styles';

// Every colour DataTable paints, derived from the theme the same way MUI X's DataGrid
// derives its own so both look alike while grids migrate. Moving off MUI means
// changing this function, not the table.
export default function getDataTableTokens(theme: Theme, surfaceColor?: string) {
  const isDarkMode = theme.palette.mode === 'dark';
  const { divider, primary } = theme.palette;
  const paperColor = theme.palette.background.paper;
  const opaqueDivider = alpha(divider, 1);

  const surfaceTokens = surfaceColor
    ? {
        bodyBackground: surfaceColor,
        containerBackground: surfaceColor,
        containerShadow: 'none',
        headerBackground: surfaceColor,
      }
    : {};

  return {
    bodyBackground: isDarkMode ? theme.semantic.surfaceRaised : paperColor,
    borderColor: divider,
    borderRadius: theme.shape.borderRadius,
    containerBackground: isDarkMode ? theme.semantic.surfaceRaised : 'transparent',
    containerShadow: isDarkMode
      ? 'inset 0 1px 0 0 rgba(255, 255, 255, 0.06), 0 2px 8px 0 rgba(0, 0, 0, 0.45)'
      : 'none',
    // DataGrid lifts its header 5% towards white in dark mode.
    headerBackground: isDarkMode ? lighten(paperColor, 0.05) : paperColor,
    resizeHandleActiveColor: primary.main,
    // The border colour MUI uses for TableCell, and DataGrid for its column separators
    // and the line under its header.
    separatorColor: isDarkMode
      ? darken(opaqueDivider, 0.68)
      : lighten(opaqueDivider, 0.88),
    ...surfaceTokens,
  };
}
